const uk = {
  navigation: {
    about: "Про нас",
    philosophy: "Наша філософія",
    contacts: "Контакти",
    events: "Події",
    main: "Головна",
    tips: "Корисності",
    team: "Команда",
    projects: "Проєкти",
    reports: "Звітності",
  },
  adminPage: {
    title: "Вхід до адмін панелі",
    loginBtn: "Увійти з",
    loginSuccessText: "Ви увійшли як",
    loginErrorText: "Помилка входу",
    signOutErrorText: "Помилка виходу",
    signOutSuccessText: "Ви вийшли",
  },
  adminContentPage: {
    signOutBtn: "Вийти",
  },
  adminsList: {
    title: "Список адміністраторів",
    altText: "Акаунти не знайдено",
    deleteSuccess: "Успішно видалено",
    deleteError: "Помилка видалення",
    youText: "Ви",
  },
  addAdminsModal: {
    label: "Gmail акаунт адміністратора",
    addAdminBtn: "Додати",
    closeBtn: "Закрити",
    addAccountSuccess: "Акаунт успішно додано",
    addAccountError: "Помилка додавання акаунту",
  },
  addNewsForm: {
    title: "Додати новину",
    labelTitleUkr: "Український заголовок",
    labelTextUkr: "Український текст",
    labelTitleEng: "Англійський заголовок",
    labelTextEng: "Англійський текст",
    labelImages: "Зображення (URL, через кому)",
    addNewsBtn: "Додати",
    addError: "Помилка додавання новини",
    addSuccess: "Новину успішно додано",
    emptyFields: "Не всі поля заповнені",
    updateSuccess: "Новину успішно оновлено",
    updateError: "Помилка оновлення новини",
    updateBtn: "Оновити",
  },
  deleteNewsButton: {
    text: "Видалити",
    deleteSuccess: "Новину успішно видалено",
    deleteError: "Помилка видалення новини",
  },
  newEventForm: {
    formTitle: "Додати нову подію",
    titleUk: "Заголовок українською",
    titleEn: "Заголовок англійською",
    descriptionUk: "Опис українською",
    descriptionEn: "Опис англійською",
    descriptionPlaceholder: "Додайте короткий опис події...",
    descriptionHint: "Shift + Enter — новий рядок",
    eventLink: "Посилання",
    startDate: "Дата початку",
    endDate: "Дата кінця",
    save: "Зберегти",
    loadingMessage: "Додавання...",
    successMessage: "Успішно!",
    errors: {
      validationError: "Не всі поля заповнені!",
      unknownError: "Невідома помилка!",
    },
    updateBtn: "Оновити",
    updateSuccess: "Подію успішно оновлено",
    updateError: "Помилка оновлення події",
  },
  switch: "EN",
  feedbackForm: {
    formName: "Форма зворотного зв'язку",
    nameField: "Повне ім'я",
    emailField: "Ваша електронна пошта",
    phoneField: "Ваш номер телефону",
    messageField: "Ваше повідомлення ...",
    buttonText: "Надіслати",
    agreement: "Я погоджуюсь з обробкою своїх персональних даних",
    resultSuccess: "Успіх",
    resultError: "Щось пішло не так",
    resultErrorInputs: "Деякі поля неправильно заповнено",
  },
  main: {
    organizationLabel: "ГРОМАДСЬКА ОРГАНІЗАЦІЯ",
    activeGAboutInfo:
      "Ми - молодіжна і волонтерська ініціатива неформальної освіти",
    activeGPurpose: {
      activeGPurposeTitle: "Мета",
      activeGPurposeInfo:
        "- зробити молодь України більш успішною, амбіційною та пристосованою до змін за допомогою проведення проєктів, зустрічей та ініціатив;",
      activeGPurposeInfo1:
        "- збудувати спільноту освічених лідерів, які змінюватимуть світ;",
      activeGPurposeInfo2:
        "- підштовхнути світ до змін та реалізацій ідей за допомогою ініціатив, які ми створюємо.",
    },
    activeGVolunteering: {
      activeGVolunteeringTitle: "Волонтерство",
      activeGVolunteeringInfo:
        "Наші круті тіммейти створюють потужну силу інновацій, які з великою мотивацію розвивають молодіжний рух, використовуючи власний досвід, знання, можливості та свої здібності.",
    },
    activeGPrinciples: {
      activeGPrinciplesTitle: "Цінності",
      activeGPrinciplesInfo:
        "ACTIVE Generation пропонує спробувати свої сили у різних напрямках волонтерства від менторів до СММ. Для нашої команди, важливо аби кожен тіммейт проявляв свою ініціативність, експертність та відданість своїй справі.",
    },
    readMoreBtn: "Докладніше",
  },
  deleteBtn: "видалити",
  joinButton: "Записатись",
  ourPhilosophy: {
    title: "Наша філософія",
    leadership: "Лідерство разом з ActiveG",
    leadershipContent:
      "ACTIVE Generation – це ініціативна громадська спільнота, яка сприяє всебічному розвитку лідерства серед української молоді та просуває ідею неформальної освіти",
    ownImproving: "Особисте вдосконалення",
    ownImprovingContent:
      "ACTIVE Generation прагне формувати спільноту, яка має бажання до вдосконалення свого навчання, особистісного зростання та розвитку навичок, які дозволять їй бути ефективними агентами позитивних змін.",
    growingTogether: `Об'єднуємось та зростаємо разом`,
    growingTogetherContent: `ACTIVE Generation об'єднує сотні молодих та енергійних людей з усіх куточків України. Активно працює над зростанням лідерських якостей учасників шляхом проведення тренінгів та вебінарів, команда експертів допомагає молоді розвивати навички комунікації, прийняття рішень, ефективного управління та співпраці.`,
  },
  returnHomeBtn: "Повернутись на головну сторінку",
  cancelBtn: "Відхилити",
  confirmDelete: "Ви дійсно хочете видалити картку?",
  cityMykolaiv: "Україна, м. Миколаїв",
  deleteToastMessage: {
    success: "Картку видалено",
    fail: "Щось пішло не так",
  },
  callToActionBlock: {
    textContentPhilosophyBlock: "Стань частиною спільноти, що змінює майбутнє!",
    textContentVideoBlock: "Зацікавив наш проєкт? Тоді...",
    joinOrganizationButtonPhilosophyBlock: "Приєднатись",
    joinOrganizationButtonVideoBlock: "Доєднуйся!",
    joinOrganizationButtonHeaderBlock: "Долучитись",
  },
  newsPage: {
    title: "Корисності",
    label: "Новини та оновлення",
    intro: "Актуальні новини, події та історії ACTIVE Generation — усе важливе про життя спільноти в одному місці.",
  },
  newsList: {
    eyebrow: "Новина",
    noNews: "Новини відсутні",
    loadMoreBtn: "Завантажити ще",
    readMore: "Читати більше",
  },
  newsDetailPage: {
    newsLabel: "Новина",
    backToNews: "До всіх новин",
    notFoundTitle: "Новину не знайдено",
    notFoundText: "Схоже, ця новина була видалена або посилання більше неактуальне.",
  },
  organizersPage: {
    title: "Команда",
    intro: "Люди, які створюють ACTIVE Generation: розвивають ідеї, запускають проєкти та формують спільноту, де молодь отримує простір для дії й розвитку.",
    showContactsBtn: "Показати контакти",
    deleteOrganizerBtn: "Видалити організатора",
    deleteOrganizerSuccess: "Організатор успішно видалений",
    deleteOrganizerError: "Помилка видалення організатора",
  },
  addOrganizerModal: {
    title: "Додати організатора",
    nameEng: "Ім'я (англійською)",
    nameUkr: "Ім'я (українською)",
    positionEng: "Посада (англійською)",
    positionUkr: "Посада (українською)",
    contacts: "Контакти",
    photo: "Фото (URL)",
    additionalInfoEng: "Додаткова інформація (англійською)",
    additionalInfoUkr: "Додаткова інформація (українською)",
    addBtn: "Додати",
    addSuccess: "Організатора успішно додано",
    addError: "Помилка додавання організатора",
    emptyFields: "Не всі поля заповнені",
    updateBtn: "Оновити",
    updateSuccess: "Організатора успішно оновлено",
    updateError: "Помилка оновлення організатора",
  },
  eventsList: {
    title: "Календар подій",
    intro: "Обирай можливість, долучайся та створюй зміни разом з нами.",
    calendar: "Найближчі події",
    noEvents: "Подій немає",
  },
  videoSection: {
    title: "Дивись, як ми створюємо зміни",
    description: "Знайомся з Active Generation ближче — нашими проєктами, людьми та атмосферою спільноти.",
  },
  footer: {
    description: "Молодіжна спільнота, що створює можливості для розвитку, лідерства та позитивних змін.",
    navigationTitle: "Навігація",
    pagesTitle: "Сторінки",
    socialTitle: "Ми онлайн",
  },
  organizerDetailPage: {
    notFound: "Такого організатора не знайдено",
    linkCopied: "Посилання скопійовано",

    backToTeam: "Назад до команди",
    memberEyebrow: "Команда ACTIVE Generation",
    about: "Про учасника команди",
    contacts: "Контакти",
    copyLink: "Скопіювати посилання",
    profileLabel: "Профіль учасника",
    shareProfile: "Поділитися профілем",
  },
  reportsPage: {
    title: "Звітності",
    intro: "Документи та звіти ACTIVE Generation, доступні для перегляду й завантаження.",
  },
  reportsList: {
    sectionTitle: "Файли звітностей",
    addTitle: "Додати звіт",
    titleUk: "Назва звіту українською",
    titleEn: "Назва звіту англійською (необов’язково)",
    titlePlaceholder: "Наприклад, Річний звіт 2026",
    titleEnPlaceholder: "For example, Annual report 2026",
    url: "URL-адреса файлу",
    urlPlaceholder: "/doc/Брендбук_Active Generation_2026.pdf",
    urlHint: "Вставте шлях до файлу на сайті (наприклад, /doc/report.pdf) або повну URL-адресу https://...",
    addButton: "Додати звіт",
    adding: "Додавання...",
    addSuccess: "Звіт успішно додано",
    addError: "Не вдалося додати звіт",
    emptyFields: "Вкажіть назву звіту та URL-адресу файлу",
    invalidUrl: "Вкажіть шлях виду /doc/назва-файлу.pdf або повну URL-адресу http:// чи https://",
    untitled: "Звіт",
    noReports: "Звіти поки не додані",
    download: "Завантажити",
    loading: "Завантаження звітів",
    deleteButton: "Видалити звіт",
    deleteConfirm: "Видалити цей звіт зі списку?",
    deleteSuccess: "Звіт успішно видалено",
    deleteError: "Не вдалося видалити звіт",
  },
  projectsPage: {
    title: "Проєкти",
    intro: "Ініціативи ACTIVE Generation, у яких ідеї перетворюються на реальні дії, можливості для молоді та зміни у спільнотах.",
  },
  projectsList: {
    noProjects: "Проєктів немає",
    addProjectSuccess: "Проєкт успішно додано",
    addProjectError: "Помилка додавання проєкту",
  },
  projectCard: {
    readMore: "Читати більше",
    duration: "Тривалість",
    purpose: "Мета",
    results: "Результати",
    cooperation: "Співпраця",
    deleteBtn: "Видалити проєкт",
    deleteProjectSuccess: "Проєкт успішно видалено",
    deleteProjectError: "Помилка видалення проєкту",
  },
  projectDetailPage: {
    backToProjects: "До всіх проєктів",
    notFoundTitle: "Проєкт не знайдено",
    notFoundText: "Схоже, цей проєкт було видалено або посилання більше неактуальне.",
    duration: "Тривалість",
    purpose: "Мета",
    results: "Результати",
    cooperation: "Співпраця",
  },
  addProjectModal: {
    title: "Додати проєкт",
    titleEng: "Назва (англійською)",
    titleUkr: "Назва (українською)",
    descriptionEng: "Опис (англійською)",
    descriptionUkr: "Опис (українською)",
    durationEng: "Тривалість (англійською)",
    durationUkr: "Тривалість (українською)",
    purposeEng: "Мета (англійською)",
    purposeUkr: "Мета (українською)",
    resultsEng: "Результати (англійською)",
    resultsUkr: "Результати (українською)",
    cooperationEng: "Співпраця (англійською)",
    cooperationUkr: "Співпраця (українською)",
    addBtn: "Додати",
    emptyFields: "Не всі обов'язкові поля заповнені",
    addError: "Помилка додавання проєкту",
    addSuccess: "Проєкт успішно додано",
    updateBtn: "Оновити",
    updateSuccess: "Проєкт успішно оновлено",
    updateError: "Помилка оновлення проєкту",
  },
};

export default uk;
